import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './Sidebar.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const SidebarMenu: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <ul className={concatClassName(styles['menu'], className)}>
        {children}
    </ul>
);

SidebarMenu.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

SidebarMenu.defaultProps = {
    className: undefined,
    children: undefined
};

export default SidebarMenu;
